define('controller/ErrorController',['require','lib/controller/BaseController','view/controller/error/ErrorView'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var ErrorView = require('view/controller/error/ErrorView');

    /**
     * Error Controller
     *
     * @class ErrorController
     */
    return BaseController.extend({

        _clientModel: null,

        initialize: function () {
            this._clientModel = this.getOption('clientModel');

            BaseController.prototype.initialize.apply(this, arguments);
        },

        e403: function (message) {
            if (this._clientModel) {
                this._clientModel.fetch();
            }
            this._showView('403', message);
        },

        e404: function (message) {
            this._showView('404', message);
        },

        e500: function (message) {
            this._showView('500', message);
        },

        _showView: function (type, additionalMessage) {
            this.getMainLayout().getContentRegion().show(new ErrorView({
                type: type,
                additionalMessage: additionalMessage
            }));
        }

    });

});
